export class DropdownItemReg {
    constructor(dropdownItemRegId: string, dropdownItemId: number, dropdownItemValue: string) {
        this.dropdownItemRegId = dropdownItemRegId;
        this.dropdownItemId = dropdownItemId;
        this.dropdownItemValue = dropdownItemValue;
        this.isValid = true;
        this.eventTypeGroupSequenceIdentity = null;
    }
    dropdownItemRegId: string;
    dropdownItemId: number;
    dropdownItemValue: string;
    isValid: boolean;
    eventTypeGroupSequenceIdentity: string | null; // View model
}
